import React from 'react';

const RedirectLabel=()=><center><label>Redireccionando...</label></center>;

export default RedirectLabel;